export interface FaqItem {
  q: string;
  a: string;
}

/**
 * Default homepage / support FAQ. Kept in a server-safe module (no "use client")
 * so both the client `<Faq>` component and server components (e.g. FAQPage
 * JSON-LD on the homepage) can import the actual array.
 */
export const FAQ_ITEMS: readonly FaqItem[] = [
  {
    q: "Do guests need to download an app?",
    a: "No! Guests simply scan a QR code and can start taking photos instantly through their phones. No app download, no sign-up required. It's completely frictionless.",
  },
  {
    q: "How many photos can each guest take?",
    a: "You decide! When creating your event, you can set the number of shots each guest gets. The choices are 8, 16, 24, or 36 photos, just like a real disposable camera roll.",
  },
  {
    q: "When do the photos get revealed?",
    a: "Photos stay hidden until the reveal time you set. This could be at midnight, the end of your event, or any specific time. When the reveal happens, everyone sees all photos at once, creating a magical shared experience.",
  },
  {
    q: "How do I download all the photos?",
    a: "After the reveal, you can download all photos at once in their original quality.",
  },
  {
    q: "What happens if I run out of shots?",
    a: "That's part of the magic! Limited shots make every photo intentional.",
  },
  {
    q: "Is my data safe?",
    a: "Absolutely. All photos are encrypted and stored securely. Only you and your invited guests can access your event's photos. We never share or use your photos for anything else.",
  },
] as const;
